/* SuperDokan catalog loader: isolated events, validated pages, recoverable failures. */
(function () {
  'use strict';
  if (window.sdCatalogLoader) return;
  var gridClasses = ['collection__page-products-1', 'collection__page-products-2', 'collection__page-products-3', 'collection__page-products'];
  var pending = false, paused = false, observer = null, queued = false;
  var seen = new Set(), context = '', lastGrid = null, emptyBatches = 0;
  var rootSelector = '#CollectionProductGrid .searchtap-temp';
  var gridSelector = '#main-collection-product-grid, .productList .list-view-items';
  var linkSelector = '.infinitpagin a.infinite, .infinitpagin a.loadMore';
  var arabic = /^ar\b/i.test(document.documentElement.lang);
  var text = arabic ? {
    loading: 'جار تحميل المنتجات...', more: 'عرض المزيد من المنتجات',
    retry: 'تعذر التحميل. اضغط للمحاولة مجدداً.'
  } : {
    loading: 'Loading more products...', more: 'Load more products',
    retry: 'Could not load products. Tap to retry.'
  };

  window.toggleProductGrid = function (lines) {
    var grid = document.getElementById('main-collection-product-grid');
    var n = Number(lines);
    if (!grid || !Number.isInteger(n) || n < 1 || n > 4) return;
    grid.classList.remove.apply(grid.classList, gridClasses);
    grid.classList.add(gridClasses[n - 1]);
    document.querySelectorAll('.st-grid-changer button').forEach(function (button) {
      button.classList.toggle('active', Number(button.getAttribute('data-grid-layout-columns')) === n);
    });
  };
  window.toggleGridClass = function (value) {
    var grid = document.getElementById('main-collection-product-grid');
    var cls = {'1': gridClasses[0], '2': gridClasses[3], '3': gridClasses[2]}[String(value)];
    if (!grid || !cls) return;
    grid.classList.remove.apply(grid.classList, gridClasses);
    grid.classList.add(cls);
  };

  function nextUrl(raw, base) {
    if (typeof raw !== 'string' || !raw.trim()) return null;
    try {
      var current = new URL(base), url = new URL(raw, current);
      var page = Number(url.searchParams.get('page'));
      var currentPage = Number(current.searchParams.get('page') || 1);
      if (!/^https?:$/.test(url.protocol) || url.origin !== current.origin ||
          url.username || url.password || url.pathname !== current.pathname ||
          !url.pathname.includes('/collections/') || !Number.isSafeInteger(page) || page <= currentPage) return null;
      if (current.searchParams.has('preview_theme_id')) {
        url.searchParams.set('preview_theme_id', current.searchParams.get('preview_theme_id'));
      }
      url.hash = '';
      return url;
    } catch (_) { return null; }
  }
  function root() { return document.querySelector(rootSelector); }
  function anchor(container) { return container && container.querySelector(linkSelector); }
  function disconnect() { if (observer) observer.disconnect(); }
  function resetContext(grid) {
    var key = window.location.pathname + window.location.search;
    if (key !== context || grid !== lastGrid) {
      seen.clear(); paused = false; emptyBatches = 0;
      context = key; lastGrid = grid;
    }
  }
  function label(link, state) {
    if (!link) return;
    link.textContent = text[state];
    link.classList.add('btn');
    link.setAttribute('aria-label', text[state]);
    if (state === 'loading') link.setAttribute('aria-disabled', 'true');
    else link.removeAttribute('aria-disabled');
  }

  async function loadMore(raw) {
    var container = root(), grid = container && container.querySelector(gridSelector);
    var link = anchor(container);
    if (!grid || !link) return false;
    resetContext(grid);
    var url = nextUrl(raw || link.getAttribute('href'), window.location.href);
    if (pending || !url || seen.has(url.href) || !window.fetch || !window.AbortController) return false;
    var pageContext = window.location.pathname + window.location.search;
    var oldFirst = grid.firstElementChild, oldLast = grid.lastElementChild;
    var oldHref = link.getAttribute('href');
    function unchanged() {
      return grid.isConnected && container.isConnected && root() === container &&
        container.querySelector(gridSelector) === grid && anchor(container) === link &&
        grid.firstElementChild === oldFirst && grid.lastElementChild === oldLast &&
        link.getAttribute('href') === oldHref &&
        window.location.pathname + window.location.search === pageContext;
    }
    pending = true; paused = false; disconnect();
    grid.setAttribute('aria-busy', 'true'); label(link, 'loading');
    var controller = new AbortController();
    var timer = window.setTimeout(function () { controller.abort(); }, 15000);
    try {
      var response = await fetch(url.href, {credentials: 'same-origin', signal: controller.signal});
      if (!response.ok) throw new Error('Catalog HTTP ' + response.status);
      var actual = new URL(response.url || url.href);
      if (actual.origin !== url.origin || actual.pathname !== url.pathname ||
          actual.searchParams.get('page') !== url.searchParams.get('page')) throw new Error('Unexpected catalog redirect');
      if (!(response.headers.get('content-type') || '').toLowerCase().includes('text/html')) throw new Error('Expected catalog HTML');
      var html = await response.text();
      if (!unchanged()) return false;
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var incomingRoot = parsed.querySelector(rootSelector);
      var incomingGrid = incomingRoot && incomingRoot.querySelector(gridSelector);
      if (!incomingGrid) throw new Error('Missing catalog grid');
      var incomingLink = anchor(incomingRoot);
      var following = incomingLink && nextUrl(incomingLink.getAttribute('href'), url.href);
      if (incomingLink && (!following || seen.has(following.href))) throw new Error('Invalid next-page link');
      // Insert only product markup, never executable scripts or a whole error page.
      incomingGrid.querySelectorAll('script').forEach(function (script) { script.remove(); });
      var fragment = document.createDocumentFragment();
      var count = incomingGrid.children.length;
      Array.from(incomingGrid.children).forEach(function (child) { fragment.appendChild(child); });
      grid.appendChild(fragment);
      seen.add(url.href);
      emptyBatches = count ? 0 : emptyBatches + 1;
      var pagination = link.closest('.infinitpagin');
      if (following) {
        link.setAttribute('href', following.pathname + following.search);
        label(link, 'more');
      } else if (pagination) pagination.remove();
      // Avoid unbounded automatic fetching through sold-out batches. A real link remains.
      if (emptyBatches >= 3) paused = true;
      if (window.lazySizes && window.lazySizes.loader) window.lazySizes.loader.checkElems();
      grid.dispatchEvent(new CustomEvent('sd:catalog:appended', {bubbles: true, detail: {count: count}}));
      return true;
    } catch (_) {
      if (unchanged()) { paused = true; label(link, 'retry'); }
      return false;
    } finally {
      window.clearTimeout(timer);
      grid.removeAttribute('aria-busy');
      link.removeAttribute('aria-disabled');
      if (link.isConnected && link.getAttribute('aria-label') === text.loading) label(link, 'more');
      pending = false;
      // Observer is re-armed only for a successful/current view, not an automatic error loop.
      arm();
    }
  }
  function nearEnd() {
    queued = false;
    var container = root(), grid = container && container.querySelector(gridSelector);
    if (!grid) return;
    resetContext(grid);
    var link = anchor(container);
    if (pending || paused || !link || !link.classList.contains('infinite') || !link.getClientRects().length) return;
    if (link.getBoundingClientRect().top < window.innerHeight + 300) loadMore(link.getAttribute('href'));
  }
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(nearEnd);
  }
  function arm() {
    disconnect();
    var container = root(), grid = container && container.querySelector(gridSelector);
    if (!grid) return;
    resetContext(grid);
    var link = anchor(container);
    if (pending || paused || !link || !link.classList.contains('infinite')) return;
    if (observer) observer.observe(link);
    else schedule();
  }
  function init() {
    if (window.innerWidth <= 768) window.toggleProductGrid(2);
    var slider = document.getElementById('collectionGridToggleSlider');
    if (slider && !slider.dataset.bound) {
      slider.dataset.bound = 'true';
      slider.addEventListener('input', function () { window.toggleGridClass(this.value); });
    }
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) nearEnd();
      }, {rootMargin: '300px 0px'});
    }
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest(linkSelector);
      var container = root();
      if (!link || !container || !container.contains(link) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
      if (!window.fetch || !window.AbortController || !nextUrl(link.getAttribute('href'), window.location.href)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      emptyBatches = 0;
      loadMore(link.getAttribute('href'));
    }, true);
    window.addEventListener('scroll', schedule, {passive: true});
    window.addEventListener('resize', schedule, {passive: true});
    window.addEventListener('popstate', arm);
    document.addEventListener('shopify:section:load', arm);
    arm();
  }
  window.sdCatalogLoader = {loadMore: loadMore, refresh: arm};
  // Preserve existing integration entry points without removing another app's listeners.
  window.infiniteScroll = arm;
  window.loadMoreBtn = arm;
  window.loadMore = loadMore;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
}());
